<template>
  <el-form>
    <el-form-item
      v-if="
        data.type !== 'editor' &&
        Object.keys(data.eventOptions).indexOf('count') >= 0
      "
      label="选择计算字段"
    >
      <br />
      <el-transfer
        @change="changeValue"
        v-model="data.eventOptions.count.list"
        :props="{ key: 'model', label: 'name' }"
        :data="dataList"
        :titles="['可选项', '已选项']"
      >
      </el-transfer>
    </el-form-item>
    <el-form-item label="已选对应项">
      <br />
      <draggable
        tag="ul"
        :list="data.eventOptions.count.list"
        v-bind="{
          group: { name: 'options' },
          ghostClass: 'ghost',
          handle: '.drag-item',
        }"
        handle=".drag-item"
      >
        <li
          v-for="(item, index) in data.eventOptions.count.list"
          :key="index"
          class="sw-li-count"
        >
          <i
            class="drag-item1"
            style="font-size: 16px; margin: 0 5px; cursor: move"
            ><i class="iconfont icon-icon_bars"></i
          ></i>
          {{ nameMap[item] }} <span class="sw-daihao">代号：</span>
          <span class="sw-daihao">
            <el-select
              v-model="data.eventOptions.count.relation[item]"
              placeholder="请选择代号"
            >
              <el-option v-for="it in alpha" :key="it" :label="it" :value="it">
              </el-option>
            </el-select>
          </span>
          <span class="sw-alpha">{{
            data.eventOptions.count.relation[item]
          }}</span>
        </li>
      </draggable>
    </el-form-item>
    <el-form-item label="自定义计算">
      <el-tooltip
        class="item"
        effect="dark"
        placement="bottom-start"
        style="margin-right: 10px"
      >
        <div slot="content" class="dateConfigDiv">
          <span class="dateConfigSpan">代号表示该行字段值</span><br /><br />
          <span class="dateConfigSpan">自定义计算遵循javaScript规范</span><br />
          <span class="dateConfigSpan spanFontW">
            <br />eg. $A+$B-$C*$D/$E 加减乘除 <br />eg. ($A+$B)*$C*$D 括弧
            <br />eg. parseInt($A+"")+$B 数字字符串转整数<br />
            <br />自定义字符请勿和代号重复 <br
          /></span>
        </div>
        <span style="color: #ff9343"><i class="el-icon-warning"></i></span>
      </el-tooltip>
      <br />
      <el-input
        type="textarea"
        :rows="3"
        placeholder="输入自定义计算代码"
        v-model="data.eventOptions.count.formula"
      >
      </el-input>
    </el-form-item>

    <el-form-item label="结果处理">
      <el-tooltip
        class="item"
        effect="dark"
        placement="bottom-start"
        style="margin-right: 10px"
      >
        <div slot="content" class="dateConfigDiv">
          <span class="dateConfigSpan">result 代表返回结果</span><br /><br />
          <span class="dateConfigSpan">自定义计算遵循javaScript规范</span><br />
          <span class="dateConfigSpan spanFontW">
            <br />eg. result +"" 转换成字符串<br />
            <br />自定义字符请勿和代号重复 <br
          /></span>
        </div>
        <span style="color: #ff9343"><i class="el-icon-warning"></i></span>
      </el-tooltip>
      <br />
      <el-input
        type="textarea"
        :rows="3"
        placeholder="定义结果数据处理"
        v-model="data.eventOptions.count.result"
      >
      </el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import Draggable from 'vuedraggable'
export default {
  name: 'sw-count',
  components: {
    Draggable,
  },
  props: ['designId', 'dataList', 'isSon', 'data', 'nameMap'],
  data() {
    return {
      alpha: [
        '$A',
        '$B',
        '$C',
        '$D',
        '$E',
        '$F',
        '$G',
        '$H',
        '$I',
        '$J',
        '$K',
        '$L',
        '$M',
        '$N',
        '$O',
        '$P',
        '$Q',
        '$R',
        '$S',
        '$T',
        '$U',
        '$V',
        '$W',
        '$X',
        '$Y',
        '$Z',
      ],
    }
  },
  created() {},
  methods: {
    changeValue(value) {
      if (value && value.length > 0) {
        const oldRelation = this.data.eventOptions.count.relation
        const newRelation = {}
        for (let i = 0; i < value.length; i++) {
          if (Object.keys(oldRelation).indexOf(value[i]) >= 0) {
            this.$set(newRelation, value[i], oldRelation[value[i]])
          } else {
            this.$set(newRelation, value[i], '')
          }
        }
        if (Object.keys(this.data.eventOptions.count).indexOf('relation') < 0) {
          this.$set(this.data.eventOptions.count, 'relation', newRelation)
        }
      } else {
        this.data.eventOptions.count.relation = {}
      }
    },
  },
}
</script>

<style scoped>
.sw-li-count {
  list-style: none;
  margin-top: 10px;
  width: 100%;
}
.sw-daihao {
  margin-left: 20px;
  font-weight: bold;
}
.sw-alpha {
  margin-left: 20px;
  font-weight: bold;
  color: #409eff;
}
.dateConfigDiv {
  margin-left: 10px;
}
.spanFontW {
  font-weight: bold;
}
</style>
